// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace BazaInviteCodeModels {
    export const UNLIMITED_CONSUME_LIMIT = -1;
}
